import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' },
  ];

  const services = [
    'Consulting Services',
    'Resource Connections',
    'Job Placement',
    'Tax Services',
    'Community Support',
  ];

  return (
    <footer className="footer bg-primary-light">
      <div className="container">
        <div className="row g-4">
          {/* About Section */}
          <motion.div
            className="col-lg-4 col-md-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h5 className="footer-title">
              <i className="bi bi-heart-pulse-fill me-2 text-primary-orange"></i>
              MWC Connections
            </h5>
            <p className="footer-description">
              Bridging communities through comprehensive support services. We connect people with resources,
              opportunities, and expertise to help them thrive.
            </p>
            <div className="social-links">
              <motion.a
                href="#"
                className="social-link bg-primary-teal"
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="bi bi-facebook"></i>
              </motion.a>
              <motion.a
                href="#"
                className="social-link bg-primary-purple"
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="bi bi-twitter"></i>
              </motion.a>
              <motion.a
                href="#"
                className="social-link bg-primary-orange"
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="bi bi-linkedin"></i>
              </motion.a>
              <motion.a
                href="#"
                className="social-link bg-primary-teal"
                whileHover={{ scale: 1.1, rotate: 5 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="bi bi-instagram"></i>
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            className="col-lg-2 col-md-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>
                    <i className="bi bi-chevron-right"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            className="col-lg-3 col-md-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h5 className="footer-title">Our Services</h5>
            <ul className="footer-links">
              {services.map((service) => (
                <li key={service}>
                  <Link to="/services">
                    <i className="bi bi-chevron-right"></i>
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="col-lg-3 col-md-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h5 className="footer-title">Contact Us</h5>
            <ul className="footer-contact">
              <li>
                <i className="bi bi-envelope-fill text-primary-teal"></i>
                <a href="mailto:najebexpress@gmail.com">Send us email</a>
              </li>
              <li>
                <i className="bi bi-telephone-fill text-primary-orange"></i>
                <a href="tel:952-486-3817">952-486-3817</a>
              </li>
              <li>
                <i className="bi bi-clock-fill text-primary-purple"></i>
                <span>Mon - Fri: 9:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0">
                &copy; {currentYear} Midwest Community Connections. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p className="mb-0">
                 Crafted by <i className="bi bi-heart-fill text-primary-orange d-none"></i>   <a
                  href="https://cititekpro.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-teal text-decoration-none fw-semibold"
                >
                  CitiTekPro
                </a>
              </p>
            </div>
          </div>
          
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
